import { Box, Item } from 'devextreme-react/box';
import Toolbar, { Item as ToolbarItem } from 'devextreme-react/toolbar';
import { ValidationSummary } from "devextreme-react/validation-summary";
import {
	ExitButton,
	InvoiceDatesPanel,
	POInvoicePage,
	PurchaseOrderAddNoteButton,
	PurchaseOrderCards,
	PurchaseOrderInvoiceFiles,
	PurchaseOrderFilesButton,
	InvoiceDetailsPanel,
	PurchaseOrderNotesPanel,
	PurchaseOrderPage,
	PurchaseOrderProgress,
	SubmitInvoiceButton,
	NewCreditMemoButton
} from '../../../features/distributor/purchase-order';
import '../../../css/order.scss';
import { useAuth } from '../../../contexts/auth';
import { CompanyTypes } from '../../../types/enums';

export default function PurchaseOrderInvoicePage() {

	const { user } = useAuth();

	return (

		<PurchaseOrderPage>

			<PurchaseOrderCards showCustomerInfo={user?.companyTypeId === CompanyTypes.SERVICE_PROVIDER} />

			<PurchaseOrderProgress />

			<ValidationSummary />

			<POInvoicePage>

				<Toolbar className='button-toolbar'>
					<ToolbarItem location={'before'}>
						<SubmitInvoiceButton />
					</ToolbarItem>
					<ToolbarItem location={'before'}>
						<NewCreditMemoButton />
					</ToolbarItem>
					<ToolbarItem location={'before'}>
						<PurchaseOrderFilesButton />
					</ToolbarItem>
					<ToolbarItem location={'before'}>
						<ExitButton />
					</ToolbarItem>
					<ToolbarItem location={'after'}>
						<PurchaseOrderAddNoteButton />
					</ToolbarItem>
				</Toolbar>

				<Box>
					<Item ratio={1}>
						<InvoiceDatesPanel />
					</Item>
					<Item ratio={1}>
						<PurchaseOrderNotesPanel height={200} />
					</Item>
				</Box>

				<PurchaseOrderInvoiceFiles />

				<InvoiceDetailsPanel />

			</POInvoicePage>

		</PurchaseOrderPage>
	)
}
